/* eslint-disable linebreak-style */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable import/extensions */
/* eslint-disable react/jsx-filename-extension */

import React, { Component } from "react";

import Button from "elements/Button";

// import NotFound from 'assets/images/NotFound.png';

// eslint-disable-next-line react/prefer-stateless-function
export default class NotFoundPage extends Component {
  render() {
    return (
      <div className="flex flex-col w-full justify-center items-center min-h-96">
        <h1 className="text-theme-blue text-7xl text-center mt-10 font-bold">
          404
        </h1>
        <p className="text-theme-blue text-2xl text-center">
          Không tìm thấy trang
        </p>
        <div className="flex justify-center mt-8">
          <Button
            href="/"
            type="link"
            className="flex h-10 px-5 bg-theme-blue text-white items-center rounded transform transition duration-500 hover:bg-gray-900"
          >
            Quay Lại
          </Button>
        </div>
      </div>
    );
  }
}
